/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables as theme, baseVariables } from '@marriott/mi-ui-library';

export const StyledDatePickerExactDiv = styled.div``;

export const StyledDatePickerDiv = styled.div<{
  $isRepositionNoOfNightsRequired?: boolean;
  $isNextGenHP?: boolean;
}>`
  ${rtl`
    position: relative;

.DayPicker-Day:focus-visible .DayPicker-Day-Cell {
    border: ${toRem(2)} solid ${theme.color.base10};
    border-radius: 50%;
 }

 .DayPicker-Day:focus-visible {
  border: none;
  outline: none;
 }

  .weekend-selector-horizontal-line{
    position:relative;
    top:${toRem(16)};
    border-bottom: ${toRem(1)} solid ${theme?.color?.neutral20};
  }
  .weekend-selector-horizontal-line-flexible{
    position:relative;
    top:${toRem(24)};
    border-bottom: ${toRem(1)} solid ${theme?.color?.neutral20};
  }
  .m-switcher-tab-list-item a span {
    font-size: ${toRem(13)};
    color: ${theme?.color?.neutral40};
  }

  .weekend-selector{
    border-radius: ${toRem(52)};
    margin-top: ${toRem(24)};
    margin-left: ${toRem(2)};
    color: ${theme?.color?.merch30};
    background: ${theme?.color?.base20};
    border: ${toRem(1)} solid ${theme?.color?.neutral30};
    &.selected-state, &.disabled {
      margin: auto;
      line-height: 1.125rem;
      font-weight: 500;
      color: ${theme?.color?.merch30};
      background: ${theme?.color?.neutral10};
      border: ${toRem(1)} solid ${theme?.color?.merch30};
    }
    &:hover{
      color: ${theme?.color?.merch30};
    }
    &:focus{
      margin-left: ${toRem(2)};
    }
    .icon-calendar {
      font-size: ${toRem(14)};
    }
    .icon-calendar:before {
      width:${toRem(16)};
      height:${toRem(16)};
    }
    .icon-check {
      font-size: ${toRem(14)};
    }
    .icon-check:before {
      width:${toRem(16)};
      height:${toRem(16)};
      margin-right:${toRem(3)};
    }
  }

  @media ${theme.mediaQuery.lg} {
    .shop-dropdown-children-el {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }
  }

  .selected-month {
    background-color:${theme.color.base10};
    color:${theme.color.base20} ;
    border: ${toRem(2)} solid ${theme.color.base10};
  }
  .selected-month:hover {
    color:${theme.color.base20} ;
  }

  .DayPicker-wrapper {
    padding-bottom: ${toRem(72)}; // this is set to 72px as the height of calendar footer is 72px

    @media ${theme.mediaQuery.lg}{
      padding-bottom: 0;
    }
  }
  .date-cursor input{
    cursor:pointer;
  }
  .date-cursor label{
    cursor:pointer;
  }
  &.date-picker-wrapper{
    .date-input-field-wrapper  input{
      cursor:pointer;
    }
    &.is-inactive,
    &.is-active {
      .m-input-text-field {
        input[type=text].datepicker-input-container {
          font-weight: 700;
          font-size: ${toRem(16)};
        }
        .trailing-element {
          line-height: 150%;
        }
      }
    }

    // Add focus styling only when datepicker modal is specifically open
    // The class 'shop-datepicker-dropdown-styles' is only added when datepickerPopupOpenState && isDesktop is true
    // For mobile, we check for the presence of the modal itself
    &.is-active:has(.shop-datepicker-dropdown-styles) .m-input-text-field input[type=text].datepicker-input-container,
    &.is-active:has(.shop-datepicker-modal .m-dropdown-container) .m-input-text-field input[type=text].datepicker-input-container {
      border: ${toRem(1.5)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color.base10} !important;
    }

    ${(props: { $isNextGenHP?: boolean }) =>
      !props.$isNextGenHP
        ? `
        @media ${theme.mediaQuery.lg} and (max-width: 1199px) {
          &.is-active {
            .trailing-element {
              display: none;
            }
          }
        }
        &.is-inactive {
          .date-input-field-wrapper:not(.main-mobile-modal-datepicker-field) {
            display: flex;
            align-items: center;
            white-space: nowrap;

            .datepicker-input-ch-wrapper .m-input-text-field input.datepicker-input-container  {
              border: none !important;
              box-shadow: none !important;
              padding: 0 0 0 ${toRem(8)};
              width: var(--input-ch-width, auto);
              font-size: ${toRem(16)};
              color: ${theme?.color?.neutral40};
              font-weight: 500;
              height: auto;
              @media ${theme.mediaQuery.lg} {
                font-size: ${toRem(16)};
              }
            }

            .m-input-text-field input.datepicker-input-container {
              border: none !important;
              box-shadow: none !important;
              padding: 0 0 0 ${toRem(8)};
              field-sizing: content;
              font-size: ${toRem(14)};
              color: ${theme?.color?.neutral40};
              font-weight: 500;
              height: auto;
              @media ${theme.mediaQuery.lg} {
                font-size: ${toRem(16)};
              }
            }

            .datepicker-nights-text-inactive {
              display: none;
              @media ${theme.mediaQuery.lg} {
                display: inline;
                margin-left: ${toRem(2)};
                color: ${theme?.color?.neutral40};
                white-space: nowrap;
              }
            }

            .datepicker-icon-wrapper {
              display: flex;
              align-items: center;
              flex-shrink: 0;
              .icon-stay-dates {
                font-size: ${toRem(20)};
                line-height: ${toRem(20)};
              }
            }
          }`
        : `
      `}

      .date-input-field-wrapper.main-mobile-modal-datepicker-field {
        padding: 0;

        .datepicker-icon-wrapper,
        .datepicker-nights-text-inactive {
          display: none;
        }
      }
    }

    @media ${theme.mediaQuery.lg}{
      .shop-datepicker-dropdown{
        margin-top: ${(props: { $isNextGenHP?: boolean }) => (props.$isNextGenHP ? toRem(0) : toRem(8))};
      }
      .shop-datepicker-dropdown-styles{
        min-height:unset;
        height:auto !important;
        display: block !important;
      }
    }
    .align-right {
        right: 0 !important;
    }
    .shop-datepicker-dropdown {
      .modal-header-input .m-input-text-field {
        width: auto;
      }
    }
    &.date-picker-mobile-wrapper{
      .modal-header-input{
        position: fixed;
        z-index: 1012;
        background: ${baseVariables.color['base20']};
        padding-bottom: ${toRem(24)} !important;
        width: calc(100% - ${toRem(32)});
        margin-top: ${toRem(40)};
        input{
          border-color:${theme.color.base10} !important;
        }
        .modal-header-input{
          @media ${theme.mediaQuery.lg}{
            padding-bottom: ${toRem(8)};
          }
        }
      }
      &.date-picker-mobile-wrapper .m-dropdown-header{
        padding-left:0;
        padding-right:0;
        position: fixed;
        top: initial;
        z-index: 1012;
        padding-top: ${toRem(1)};
        margin-top: ${toRem(-1)};
        background: ${baseVariables.color['base20']};
        width: calc(100% - ${toRem(32)});
        &:after{
          width:100%;
        }
      }
      .modal-header-sticky{
        position: relative;

        @media ${theme.mediaQuery.lg}{
          margin-top: 0;
        }
      }
    }
    .datepicker-dropdown-wrapper {
      position: relative;
    }

    .shop-datepicker-modal{
      width:100%;
      .shop-date-picker-drop-down-cn{
        @media ${theme.mediaQuery.lg} {
          .DayPicker-WeekdaysRow {
            gap: ${toRem(4.8)};
          }
        }
      }
      .dropdown-to-modal{
        height: 80vh;
        max-height: 80vh !important;
        padding: ${toRem(24)};
        padding-bottom: 0;
        @media ${theme.mediaQuery.md}{
          position:fixed;
        }

        .m-dropdown-content{
          padding: 0 !important;
          margin-top: 0;
          height: calc(80vh - ${toRem(88)}) !important;
          max-height: calc(80vh - ${toRem(88)}) !important;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: transparent transparent;
          &::-webkit-scrollbar {
            width: 0;
          }
          &::-webkit-scrollbar-track {
            background: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background-color: transparent;
          }
        }
      }


      .DayPicker-Month {
        width:calc(100vw - ${toRem(32)}) !important;
      }
      @media ${theme.mediaQuery.lg}{
        .DayPicker-Months {
          gap:${toRem(32)}
        }
        .DayPicker-NavButton--next{
          right:0 !important;
        }
        .DayPicker-NavButton--prev{
          left:0 !important;
        }
        .DayPicker-Month {
          width:${toRem(316)} !important;
          margin-left:0 !important;
          margin-right:0 !important;
          margin-top: ${toRem(16)} !important;
        }
        .DayPicker-Weekdays {
          display:flex;
        }
        .DayPicker-WeekdaysRow {
          display: flex;
          width:100%;
          justify-content:space-around;
        }
        .DayPicker-Body {
          display:flex;
          flex-direction: column;
          align-items: center;
        }

        .DayPicker-Week {
          display: flex;
          width:100%;
          justify-content:space-around;
          align-items:stretch;
        }
        .DayPicker-Day {
          display: flex;
          height: ${toRem(40)};
          justify-content: center;
          align-items: center;
          width: 100%;
        }
        .DayPicker-Body{
          .DayPicker-Week{
            .DayPicker-Day{
              &.DayPicker-Day--hoverRange:not(.DayPicker-Day--selected){
                .DayPicker-Day-Cell{
                  width:100% !important;
                }
              }
              &.DayPicker-Day--hoverRange{
                &.DayPicker-Day--select {
                  background-color:${baseVariables.color['neutral10']} !important;
                  width:100% !important;
                }
              }
            }
          }
        }
        .DayPicker-Day-Cell:focus-visible{
          border-radius:50%;
        }
        .DayPicker-Weekdays {
          abbr {
            cursor:auto;
          }
        }
        ${(props: { $isNextGenHP?: boolean }) =>
          props.$isNextGenHP
            ? `
          /* Center modal with datepicker input container for nextGenHP on desktop */
          @media ${theme.mediaQuery.desktop} {
            position: absolute !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            top: 100% !important;
            right: auto !important;
          }

          /* Ensure centering applies to the modal wrapper */
          .datepicker-dropdown-wrapper .shop-datepicker-modal {
            @media ${theme.mediaQuery.desktop} {
              position: absolute !important;
              left: 50% !important;
              transform: translateX(-50%) !important;
              top: 100% !important;
              right: auto !important;
            }
          }
        `
            : `
          /* Default fixed positioning for non-nextGenHP */
          position: fixed;
          left: auto;
          right: 8px;
        `}
        width:${toRem(712)};
        z-index:1011;
        &.is-search-form-sticky {
          right:0;
        }
        .m-dropdown-content{
          padding:${toRem(24)} ${toRem(24)} !important;
          max-height:100%;
          min-height:unset !important;
        }
      }
    }

    /* NextGen standard: Absolute positioning for desktop (but not NextGenHP) */
    ${(props: { $isNextGenHP?: boolean }) =>
      !props.$isNextGenHP
        ? `
        .datepicker-dropdown-wrapper .shop-datepicker-modal {
          @media ${theme.mediaQuery.desktop} {
            position: absolute !important;
            left: 0 !important;
            right: auto !important;
          }
        }
      `
        : ''}

      .icon-calendar{
        margin-right: ${toRem(4)};
      }
      .tab-wrapper{
        box-shadow: none;
        padding-bottom:0;
        padding-top: ${toRem(63)};
          ul {
          position: fixed;
          width: calc(100% - ${toRem(32)}) !important;
          background: ${baseVariables.color['neutral10']};
          z-index: 1012;
          padding: ${toRem(4)};
          margin-top: ${toRem(52)};
          border-radius: ${toRem(8)};
          display: flex;

          li{
            background: transparent;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: ${toRem(6)};
          }
          .m-switcher-tab-list-item.active{
            background: ${baseVariables.color['base20']} !important;
            box-shadow: 0 ${toRem(1)} ${toRem(3)} rgba(0, 0, 0, 0.1);
            a span {
              font-size: ${toRem(13)};
              color: ${theme?.color?.base10};
            }
          }
        }

        padding-top:${toRem(16)};
        @media ${theme.mediaQuery.lg}{
          padding-top:0;
         ul{
          width: ${toRem(327)} !important;
          align-items:center;
          justify-content:center;
          margin: 0 auto ${toRem(16)};
          position: relative;
          background: ${baseVariables.color['neutral10']};
          padding-top: ${toRem(4)};
         }
        }
      }
        box-shadow:none;
        .datepicker-calendar-wrapper-multi-tabs{
          border-top:${theme.border.borderWidth01} ${theme.border.borderStyleDefault} ${theme.color.neutral20};
        }
        .datepicker-calendar-wrapper{
          margin-top: ${toRem(82)};
          @media ${theme.mediaQuery.lg}{
            margin-top: ${toRem(0)};
          }
        }
        .datepicker-calendar-wrapper-mobile{
          margin-top: ${toRem(50)};
        }
        .datepicker-tab-wrapper{
          align-items:center;
          justify-content:center;
          margin: 0 auto ${toRem(16)};
          width:auto;
          @media ${theme.mediaQuery.lg}{
          width:${toRem(327)};
          }

        }
        .datepicker-tab-wrapper-exact{
          padding-top:${toRem(4)};
          margin-top: ${toRem(-30)};
        }
      }
  }
`}
`;

export const StyledFlexiCalendarBoxDiv = styled.div`
  ${rtl`
  &.search__flexible_calendar{
    border-top:${theme.border.borderWidth01} ${theme.border.borderStyleDefault} ${theme.color.neutral20};
    .stepper-wrapper{
      margin-top: ${toRem(130)};
      @media ${theme.mediaQuery.lg}{
        margin-top: 0;
      }
    }
    .m-stepper-label{
      min-width: ${toRem(118)};
    }

    .m-stepper{
      padding-left: ${toRem(24)};
    }
    .default-month-state {
      color: ${theme.color.neutral40};
      border-color: ${theme.color.neutral30};
      font-size: ${toRem(14)};
    }
    .default-month-state:hover{
      background-color:${theme.color.neutral20} ;
      color:${theme.color.base10} ;
      box-shadow: none;
    }
    .months-pill-container{
      padding-bottom: ${toRem(6)} !important;
      .month-pill:focus:not(:focus-visible) {
        outline: 0;
        box-shadow: none;
      }
      .month-pill{
        min-width:${toRem(104)};
        font-weight:500;
        @media only ${theme.mediaQuery.lg}{
          min-width:${toRem(100)};
        }
        &:nth-child(3){
          @media only ${theme.mediaQuery.md}{
            margin-right:${toRem(8)} !important;
          }
        }
      }
    }
  }
`}
`;

export const StyledFooterDatePickerDiv = styled.div`
  ${rtl`
      position: fixed;
      z-index: 1011;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${theme.color['base20']};
      @media ${theme.mediaQuery.lg}{
        position:static;
      }
      .reset-action-button{
        background:none;
      }
`}
`;
